import React from "react";
// import { useAuth0 } from "@auth0/auth0-react";

interface LoginButtonProps {
  className?: string;
}

const LoginButton: React.FC<LoginButtonProps> = ({ className }) => {
  //const { loginWithRedirect } = useAuth0();

  const loginHandler = () => {
    window.parent.postMessage("sc-chatbotLogin", "*");
  };

  return (
    <button onClick={() => loginHandler()} className={className}>
      <span className="text-base text-[#533366]">Log In</span>
    </button>
  );
};

export default LoginButton;
